import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Lt = ({ property, filter, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'LT')

  return (
    <div>
      <PropertyComponent
        property={property}
        filter={filter}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default Lt
